import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Input, Form as AntForm, Button } from 'antd';

import apiClient from '@/utils/feathersClient';

import type { ValidationErrorsObject } from '@/types/global';

const UserForm = () => {
  const [t] = useTranslation();

  const [errorMessage, setErrorMessage] = useState<string>('');

  const submit = async (values: {
    oldPassword: string;
    newPassword: string;
    repeatPassword: string;
  }) => {
    try {
      await apiClient.service('new-password').create(values, { query: { $setByOld: true } });
      return {};
    } catch (e: any) {
      setErrorMessage(e.message);
      return e.errors;
    }
  };

  return (
    <FinalForm
      onSubmit={submit}
      validate={validate}
      render={({ handleSubmit }) => (
        <AntForm
          layout="vertical"
          onFinish={handleSubmit}
          className="settings update-password"
        >
          <div className="settings__row settings__row_error">
            <div className="settings__error">
              <p>{errorMessage}</p>
            </div>
          </div>
          <div className="settings__row">
            <div className="settings__box settings__box_right-border">
              <div className="settings__field settings__field_padding">
                <Field name="oldPassword">
                  {({ input, meta }) => (
                    <AntForm.Item
                      label={t('lastPassword')}
                      validateStatus={meta.touched && (meta.error || meta.submitError) ? 'error' : ''}
                      help={meta.touched && (meta.error || meta.submitError) ? (meta.error || meta.submitError) : ''}
                    >
                      <Input.Password
                        {...input}
                        placeholder={t('lastPassword')}
                        className={(meta.error || meta.submitError) && meta.touched ? 'field_error' : ''}
                      />
                    </AntForm.Item>
                  )}
                </Field>
              </div>
            </div>
            <div className="settings__box">
              <div className="settings__field settings__field_padding">
                <Field name="newPassword">
                  {({ input, meta }) => (
                    <AntForm.Item
                      label={t('newPassword')}
                      validateStatus={meta.touched && (meta.error || meta.submitError) ? 'error' : ''}
                      help={meta.touched && (meta.error || meta.submitError) ? (meta.error || meta.submitError) : ''}
                    >
                      <Input.Password
                        {...input}
                        placeholder={t('newPassword')}
                        className={(meta.error || meta.submitError) && meta.touched ? 'field_error' : ''}
                      />
                    </AntForm.Item>
                  )}
                </Field>
              </div>
              <div className="settings__field">
                <Field name="repeatPassword">
                  {({ input, meta }) => (
                    <AntForm.Item
                      label={t('repeat')}
                      validateStatus={meta.touched && (meta.error || meta.submitError) ? 'error' : ''}
                      help={meta.touched && (meta.error || meta.submitError) ? (meta.error || meta.submitError) : ''}
                    >
                      <Input.Password
                        {...input}
                        placeholder={t('repeat')}
                        className={(meta.error || meta.submitError) && meta.touched ? 'field_error' : ''}
                      />
                    </AntForm.Item>
                  )}
                </Field>
              </div>
            </div>
            <div className="settings__box">
              <div className="settings__field settings__field_full">
                <Button className="btn btn_green" type="primary" htmlType="submit">
                  {t('changePassword')}
                </Button>
              </div>
            </div>
          </div>
        </AntForm>
      )}
    />
  );
};

type FormState = {
  oldPassword: string;
  newPassword: string;
  repeatPassword: string;
};

const validate = (values: Partial<FormState>) => {
  const errors: ValidationErrorsObject<FormState> = {};

  if (!values.oldPassword) {
    errors.oldPassword = 'Required';
  }
  if (!values.newPassword) {
    errors.newPassword = 'Required';
  }
  if (!values.repeatPassword) {
    errors.repeatPassword = 'Required';
  }
  if (values.newPassword && values.newPassword !== values.repeatPassword) {
    errors.repeatPassword = 'Your password and confirmation password do not match';
  }

  return errors;
};

export default UserForm;
